var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"128","height":"128","viewBox":"0 0 128 128","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('rect',{attrs:{"width":"128","height":"128","rx":"4","fill":"#F1F1F1"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }